import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Ei muokkausryhmiä vielä. Luo uusi.',
  fields: {
    name: 'Nimi',
    external_id: '{{integration}}-viite',
    prices: 'Hinnat',
    available: 'Saatavilla',
    status: 'Tila',
    statuses: {
      good: 'Hyvä',
      bad: 'Huono',
      medium: 'Keskitaso',
    },
  },
  order_method_prices: {
    base: 'Perus',
    [ORDER_METHODS.pickup]: 'Nouto',
    [ORDER_METHODS.delivery]: 'Toimitus',
    [ORDER_METHODS.on_site]: 'Pöytätilaus',
  },
  labels: {
    visible: 'Näkyvissä valikossa',
    hidden: 'Kaikki piilotettu',
  },
  buttons: {
    add_modifier: 'Lisää muokkain',
    delete_modifier_one: 'Poista muokkain',
    delete_modifier_other: 'Poista muokkaimet',
    show_modifier_group: 'Näytä muokkausryhmä',
    close_modifier_group: 'Sulje muokkausryhmä',
    edit: 'Muokkaa',
    duplicate: 'Monista',
    history: 'Historia',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Muokkausryhmän monistaminen epäonnistui',
    modifier_group_duplicated_successfully: 'Muokkausryhmä monistettu onnistuneesti',
    failed_to_duplicate_modifier: 'Muokkaimen monistaminen epäonnistui',
    modifier_duplicated_successfully: 'Muokkain monistettu onnistuneesti',
  },
};
